import Cookies from 'universal-cookie';
import ErrorHandler from '~/glm/utils/error-handler';

export default class XoApi {
  static cookies = new Cookies();

  static get(path) {
    return XoApi.baseFetch(path, {
      method: 'GET',
      headers: XoApi.baseHeaders(),
    });
  }

  static getOrCreate(path, data) {
    return XoApi.baseFetch(path, {
      method: 'GET',
      headers: XoApi.baseHeaders(),
    }).then(responseJSON => {
      if (responseJSON.length) {
        return responseJSON;
      }
      return XoApi.post(path, data).then(postJSON => (Array.isArray(postJSON) ? postJSON : [postJSON]));
    });
  }

  static post(path, data) {
    return XoApi.baseFetch(path, {
      method: 'POST',
      headers: XoApi.baseHeaders(),
      body: JSON.stringify(data),
    });
  }

  static put(path, data) {
    return XoApi.baseFetch(path, {
      method: 'PUT',
      headers: XoApi.baseHeaders(),
      body: JSON.stringify(data),
    });
  }

  static delete(path) {
    return XoApi.baseFetch(path, {
      method: 'DELETE',
      headers: XoApi.baseHeaders(),
    });
  }

  static baseFetch(path, init) {
    return fetch(`${process.env.REACT_APP_GLM_GUEST_API_ENDPOINT}${path}`, init)
      .then(XoApi.parseResponse)
      .then(XoApi.scrubResponseJSON)
      .catch(response => {
        XoApi.handleRejectedFetch(response, path, init);
        return Promise.reject(response);
      });
  }

  static parseResponse(response) {
    if (response && response.ok) {
      if (response.status >= 200 || response.status <= 299) {
        return Promise.resolve(response.json());
      } else {
        return Promise.resolve();
      }
    }

    try {
      return new Promise((_, reject) => {
        response.text().then(text => (text ? reject(JSON.parse(text)) : {}));
      });
    } catch (err) {
      return Promise.reject();
    }
  }

  static scrubResponseJSON(responseJSON) {
    function eachRecursive(obj) {
      Object.keys(obj).forEach(k => {
        if (typeof obj[k] === 'object' && obj[k] !== null) {
          eachRecursive(obj[k]);
        }
      });
    }

    eachRecursive(responseJSON);
    return Promise.resolve(responseJSON);
  }

  static handleRejectedFetch(response, path, init) {
    if (!response || !response.status) {
      XoApi.triggerErrorHandler({
        path,
        context: {
          url: path,
          request: init,
        },
      });
    } else if (response.status >= 404) {
      XoApi.triggerErrorHandler({
        path,
        context: {
          url: path,
          request: init,
          response: {
            body: response,
            status: response.status,
            statusText: response.statusText,
          },
        },
      });
    }
    return response;
  }

  static triggerErrorHandler({ path, context }) {
    ErrorHandler.notify({
      name: `GuestServicesApi Error - ${path}`,
      component: 'XoApi',
      action: 'baseFetch()',
      context,
      fingerprint: 'GLM',
      triggerHandleErrorCallback: true,
    });
  }

  static baseHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: XoApi.getSessionToken(),
    };
  }

  static getSessionToken() {
    if (!XoApi.cookies) {
      XoApi.cookies = new Cookies();
    }
    return XoApi.cookies.get('xo-session-token');
  }
}
